/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salty_Jolly_Emu_FeastInputs */

const fr_salty_jolly_emu_feast = /** @type {(inputs: Salty_Jolly_Emu_FeastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme inconnu`)
};

/**

* @param {Salty_Jolly_Emu_FeastInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const salty_jolly_emu_feast = /** @type {((inputs?: Salty_Jolly_Emu_FeastInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salty_Jolly_Emu_FeastInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_salty_jolly_emu_feast(inputs)
});